import { l } from '@manychat/manyui'

import { alert } from 'common/core'
import { IAsyncThunkActionWithReturnValue, IThunkAction } from 'common/core/interfaces/actions'
import { CreateFolderResponse } from 'common/core/interfaces/folder'
import { tagsFoldersSlice } from 'common/tags/reducers/tagsFolder'
import { getIsFolderNameExists } from 'common/tags/selectors/tagFoldersSelectors'
import { TagsActions } from 'common/tags/store'
import { TagType } from 'shared/api/common/schemas/tag'
import { handleError } from 'shared/api/lib/errors/handlers'
import { FoldersApi } from 'shared/api/requests/folders'
import { getClientId } from 'utils/clientId'
import { anotherTabNotificationsListener } from 'utils/services/notificationsService'

const FOLDER_ENTITY_TAGS = 40
const ROOT_PATH = '/'

export const fetchTagsFolders = () =>
  tagsFoldersSlice.actions.getListFx({
    payload: { body: { entity: FOLDER_ENTITY_TAGS, path: ROOT_PATH } },
  })

export const createTagsFolder =
  (title: string): IThunkAction<Promise<CreateFolderResponse | undefined>> =>
  async (dispatch, getState) => {
    const isFolderNameExists = getIsFolderNameExists(getState(), title)

    if (isFolderNameExists) {
      alert(l.translate('Folder with this name already exists'), 'danger')
      return
    }

    try {
      const { data } = await FoldersApi.create({
        body: { title, entity: FOLDER_ENTITY_TAGS, path: ROOT_PATH },
        query: { client_id: getClientId() },
      })
      dispatch(tagsFoldersSlice.actions.appendItem({ item: data.folder }))
      alert(l.translate('Folder created'), 'success')
      return data
    } catch (error) {
      handleError(error)
      return
    }
  }

export const createFolderAndMoveTags = (title: string, tagIds: number[]): IThunkAction => {
  return async (dispatch, getState) => {
    const isFolderNameExists = getIsFolderNameExists(getState(), title)

    if (isFolderNameExists) {
      alert(l.translate('Folder with this name already exists'), 'danger')
      return
    }

    try {
      const { data } = await FoldersApi.create({
        body: { title, entity: FOLDER_ENTITY_TAGS, path: ROOT_PATH },
        query: { client_id: getClientId() },
      })
      dispatch(tagsFoldersSlice.actions.appendItem({ item: data.folder }))
      alert(l.translate('Folder created'), 'success')
      await dispatch(TagsActions.bulkMoveFx({ tagIds, folderId: data.folder.folder_id }))
    } catch (error) {
      handleError(error)
    }
  }
}

export const removeTagsFolder =
  (
    folderId: number,
    options: {
      path: string
      delete_content: boolean
    },
  ): IThunkAction =>
  async (dispatch) => {
    try {
      await FoldersApi.delete({ body: options, query: { client_id: getClientId() } })
      dispatch(tagsFoldersSlice.actions.deleteItem({ id: folderId }))
      if (!options.delete_content) {
        dispatch(
          TagsActions.getListFx({
            payload: { query: { path: '/', type: TagType.USER } },
            effectConfig: { forceRequest: true },
          }),
        )
      }
      alert(l.translate('Folder deleted!'), 'success')
    } catch (error) {
      handleError(error)
    }
  }

export const updateTagsFolderName =
  (folderId: number, path: string, title: string): IAsyncThunkActionWithReturnValue<boolean> =>
  async (dispatch, getState) => {
    const isFolderNameExists = getIsFolderNameExists(getState(), title)

    if (isFolderNameExists) {
      alert(l.translate('Folder with this name already exists'), 'danger')
      return false
    }

    try {
      await FoldersApi.rename({ body: { path, title }, query: { client_id: getClientId() } })

      dispatch(tagsFoldersSlice.actions.updateItem({ id: folderId, data: { title } }))
      alert(l.translate('Folder renamed!'), 'success')

      return true
    } catch (error) {
      handleError(error)

      return false
    }
  }

export const setSelectedTagsIds = tagsFoldersSlice.actions.setSelectedIds

export const resetSelectedTagsIds = tagsFoldersSlice.actions.resetSelectedIds

anotherTabNotificationsListener.on('folder_created', (data, dispatch) => {
  if (data.folder.entity === FOLDER_ENTITY_TAGS) {
    dispatch(tagsFoldersSlice.actions.appendItem({ item: data.folder }))
  }
})

anotherTabNotificationsListener.on('folder_renamed', (data, dispatch) => {
  if (data.folder.entity === FOLDER_ENTITY_TAGS) {
    dispatch(
      tagsFoldersSlice.actions.updateItem({
        id: data.folder.folder_id,
        data: data.folder,
      }),
    )
  }
})

anotherTabNotificationsListener.on('folder_deleted', (data, dispatch) => {
  if (data.folder) {
    if (data.folder.entity === FOLDER_ENTITY_TAGS) {
      dispatch(tagsFoldersSlice.actions.deleteItem({ id: data.folder.folder_id }))
    }
  }
})
